import {
    GERAR_ROMANEIOS,
    GERAR_ROMANEIOS_SUCESSO,
    MOSTRAR_MENSAGEM_ROMANEIOS,
    SET_DATA_INICIO_ROMANEIO,
    SET_DATA_FIM_ROMANEIO,
    SET_LOAD_GERAR_ROMANEIOS,
    ESCONDER_MENSAGEM_ROMANEIOS,
    ORDER_BY_ROMANEIOS,
    SET_LINHAS_POR_PAGINA_ROMANEIOS,
    MUDAR_PAGINA_ROMANEIOS,
    ROMANEIOS_ORDENAR,
    MARCAR_ROMANEIOS,
    MARCAR_TODOS_ROMANEIOS,
    DESMARCAR_TODOS_ROMANEIOS,
    GERAR_ROMANEIOS_LIBERADO,
    CRIAR_ROMANEIO_SEM_VERIFICAR,
    LOAD_ROMANEIOS
} from 'constants/ActionTypes';

export const gerarRomaneios = (dados) =>{
    return {
        type: GERAR_ROMANEIOS,
        payload: dados
    }
}
export const esconderMensagemRomaneios = () =>{
    return {
        type: ESCONDER_MENSAGEM_ROMANEIOS
    }
}

export const marcarRomaneios = (dados) =>{
    return {
        type: MARCAR_ROMANEIOS,
        payload: dados
    }
}
export const desmarcarTodosRomaneios = (dados) =>{
    return {
        type: DESMARCAR_TODOS_ROMANEIOS,
        payload: dados
    }
}
export const marcarTodosRomaneios = (dados) =>{
    return {
        type: MARCAR_TODOS_ROMANEIOS,
        payload: dados
    }
}
export const romaneiosOrdernar = (dados) =>{
    return {
        type: ROMANEIOS_ORDENAR,
        payload: dados
    }
}
export const mudarPaginaRomaneios = (dados) =>{
    return {
        type: MUDAR_PAGINA_ROMANEIOS,
        payload: dados
    }
}
export const setLinhasPorPaginaRomaneios = (dados) =>{
    return {
        type: SET_LINHAS_POR_PAGINA_ROMANEIOS,
        payload: dados
    }
}
export const orderByRomaneios = (dados) =>{
    return {
        type: ORDER_BY_ROMANEIOS,
        payload: dados
    }
}

export const setDataInicioRomaneio = (dados) =>{
    return {
        type: SET_DATA_INICIO_ROMANEIO,
        payload: dados
    }
}
export const setDataFimRomaneio = (dados) =>{
    return {
        type: SET_DATA_FIM_ROMANEIO,
        payload: dados
    }
}
export const gerarRomaneiosSucesso = (dados) =>{
    return {
        type: GERAR_ROMANEIOS_SUCESSO,
        payload: dados
    }
}
export const mostrarMensagemRomaneios = (dados) =>{
    return {
        type: MOSTRAR_MENSAGEM_ROMANEIOS,
        payload: dados
    }
}
export const setLoadGerarRomaneios = (dados) =>{
    return {
        type: SET_LOAD_GERAR_ROMANEIOS,
        payload: dados
    }
}
export const gerarRomaneiosLiberado = (dados) =>{
    return {
        type: GERAR_ROMANEIOS_LIBERADO,
        payload: dados
    }
}
export const criarRomaneiosSemVerificar = (dados) =>{
    return {
        type: CRIAR_ROMANEIO_SEM_VERIFICAR,
        payload: dados
    }
}
export const loadRomaneios = (dados) =>{
    return {
        type: LOAD_ROMANEIOS,
        payload: dados
    }
}
